import { render, staticRenderFns } from "./userThreparty.vue?vue&type=template&id=853194e8"
import script from "./userThreparty.vue?vue&type=script&lang=js"
export * from "./userThreparty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports